/**
 * Paste from chat rides the same upload batch as a chosen file (#1274).
 * The body is a UTF-8 Markdown file. Empty paste is ignored.
 * A second sheet kept in the same batch is "Pasted story sheet 2.md".
 */

export const STORY_SHEET_FORMAT = 'story_sheet';
export const PASTED_STORY_SHEET_FILENAME = 'Pasted story sheet.md';

export function pastedStorySheetFilename(index) {
  const n = Math.max(1, Number(index) || 1);
  if (n === 1) return PASTED_STORY_SHEET_FILENAME;
  return `Pasted story sheet ${n}.md`;
}

export function nextPastedStorySheetFilename(taken) {
  const names = taken instanceof Set ? taken : new Set(taken || []);
  let index = 1;
  let name = pastedStorySheetFilename(index);
  while (names.has(name)) {
    index += 1;
    name = pastedStorySheetFilename(index);
  }
  return name;
}

export function pasteBodyIsEmpty(text) {
  return !String(text ?? '').trim();
}

/** UTF-8 Markdown. File name is what ingest stores as the doc. */
export function syntheticMarkdownFile(text, filename) {
  return new File([String(text ?? '')], filename, { type: 'text/markdown' });
}

/**
 * Files first, then frozen pastes, then the live paste field.
 * Whitespace-only paste adds nothing.
 */
export function batchWithPaste({
  entries = [],
  frozenPastes = [],
  pasteText = '',
  pasteFormat = '',
} = {}) {
  const taken = new Set();
  const batch = [];

  entries.forEach((entry) => {
    if (entry?.file?.name) taken.add(entry.file.name);
    batch.push({
      id: entry.id,
      file: entry.file,
      declaredFormat: entry.declaredFormat,
      source: 'file',
    });
  });

  frozenPastes.forEach((paste) => {
    const name = nextPastedStorySheetFilename(taken);
    taken.add(name);
    batch.push({
      id: paste.id,
      file: syntheticMarkdownFile(paste.text, name),
      declaredFormat: paste.format,
      source: 'paste',
    });
  });

  if (!pasteBodyIsEmpty(pasteText)) {
    const name = nextPastedStorySheetFilename(taken);
    batch.push({
      id: 'paste-live',
      file: syntheticMarkdownFile(pasteText, name),
      declaredFormat: pasteFormat,
      source: 'paste',
    });
  }

  return batch;
}
